import type {UseViewEntityProps, UseViewEntityResult} from '@igp/shared/redux/view';
import {useViewInit as baseViewInit} from '@igp/shared/redux/view';
import type {EntityType} from '@models';

export function useViewInit<TItem, TFilterKey extends string, TFields extends string, TSortingFields extends string = TFields>(
    props: Omit<UseViewEntityProps<EntityType, TFilterKey, TFields, TSortingFields>, 'schemaMapper'>
): UseViewEntityResult<EntityType, TItem, TFields, TSortingFields> {
    return baseViewInit<EntityType, TItem, TFilterKey, TFields, TSortingFields>(props);
}
